/** @format */

import { blackColor, grayColor, hexToRgb, primaryBoxShadow, primaryColor, whiteColor } from '../../../../jss/material-dashboard-pro-react';
import COLORS from '../../colors';

/** @format */

const selectStyle = {
    select: {
        fontSize: '.75rem',
        fontWeight: '400',
        lineHeight: '1.42857',
        textDecoration: 'none',
        color: COLORS.MAIN.DARK,
        letterSpacing: '1',
        '&:focus': {
            backgroundColor: 'transparent',
        },
        '&[aria-owns] + input + svg': {
            transform: 'rotate(180deg)',
        },
        '& + input + svg': {
            transition: 'all 300ms linear',
        },
    },
    selected: {
        backgroundColor: '#FF0000',
    },
    selectFormControl: {
        paddingTop: 2,
        backgroundColor: '#F5F5F5',

        fontWeight: 'bold',
        margin: '0 0 17px 0 !important',
        '& > div': {
            '&:before': {
                borderBottom: `2px solid ${COLORS.DARK_FUNCTION.FUNCTION_4}`,
            },
            '&:after': {
                borderBottomColor: COLORS.MAIN.PRIMARY + '!important',
            },
        },
        '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
            color: COLORS.MAIN.DARK,
        },
    },
    selectLabel: {
        fontSize: '12px',
        color: COLORS.MAIN.DARK + ' !important',
        top: '8px',
    },
    selectMenu: {
        '& > div > ul': {
            border: '0',
            padding: '5px 0',
            margin: '0',
            boxShadow: 'none',
            minWidth: '100%',
            borderRadius: '4px',
            boxSizing: 'border-box',
            display: 'block',
            fontSize: '14px',
            textAlign: 'left',
            listStyle: 'none',
            backgroundColor: '#F5F5F5',
            backgroundClip: 'padding-box',
        },
        '& $selectPaper $selectMenuItemSelectedMultiple': {
            backgroundColor: 'inherit',
        },
        '& > div + div': {
            maxHeight: '266px !important',
        },
    },
    selectMenuItem: {
        minHeight: '20px',
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '20px',
        padding: '10px 20px',
        borderRadius: '2px',
        transition: 'all 150ms linear',
        display: 'block',
        clear: 'both',
        whiteSpace: 'nowrap',
        color: COLORS.MAIN.DARK,
        paddingRight: '30px',
        '&:hover': {
            backgroundColor: '#F5F5F5',
            color: COLORS.MAIN.DARK,
        },
    },
    selectMenuItemSelected: {
        margin: 0,
        color: COLORS.MAIN.DARK,
        backgroundColor: 'transparent !important',
        borderBottom: `1px solid ${COLORS.DARK_FUNCTION.FUNCTION_4}`,
    },
    selectMenuItemSelectedMultiple: {
        backgroundColor: 'transparent !important',
        '&:hover': {
            backgroundColor: primaryColor[0] + '!important',
            color: whiteColor,
            ...primaryBoxShadow,
            '&:after': {
                color: whiteColor,
            },
        },
        '&:after': {
            top: '16px',
            right: '12px',
            width: '12px',
            height: '5px',
            borderLeft: '2px solid currentColor',
            transform: 'rotate(-45deg)',
            opacity: '1',
            color: COLORS.MAIN.DARK,
            position: 'absolute',
            content: "''",
            borderBottom: '2px solid currentColor',
            transition: 'opacity 90ms cubic-bezier(0,0,.2,.1)',
        },
    },
    selectPaper: {
        boxSizing: 'borderBox',
        borderRadius: '4px',
        padding: '0',
        minWidth: '100%',
        display: 'block',
        border: '0',
        backgroundClip: 'padding-box',
        margin: '2px 0 0',
        fontSize: '14px',
        textAlign: 'left',
        listStyle: 'none',
        backgroundColor: 'transparent',
        maxHeight: '266px',
    },
    SelectFromRestSelectLabelRoot: {
        marginTop: 6,
        fontWeight: 'bold',
        fontSize: '14px',
        paddingLeft: 15,
        color: COLORS.MAIN.DARK + ' !important',
        fontFamily: '"Helvetica 55 Roman"',
    },
    SelectFromRestSelectMenu: {
        fontWeight: 'bold',
        fontSize: '14px',
        paddingLeft: 15,
        color: COLORS.MAIN.DARK + ' !important',
        fontFamily: '"Helvetica 55 Roman"',
        height: 26,
    },

    multiSelectMenuItem: {
        minHeight: '20px',
        fontWeight: 'bold',
        fontSize: '14px',
        paddingLeft: 15,
        color: COLORS.MAIN.DARK + ' !important',
        fontFamily: '"Helvetica 55 Roman"',
    },
    multiSelectSelectMenu: {
        fontSize: '12px',
        padding: 0,
    },
    multiSelectSelectLabelRoot: {
        fontWeight: 'bold',
        fontSize: '14px',
        paddingLeft: 15,
        color: COLORS.MAIN.DARK + ' !important',
        fontFamily: '"Helvetica 55 Roman"',
    },
};

export default selectStyle;
